import { Seo } from "../components/Seo";

// Mise en page commune des pages légales.
// NOTE : modèles à faire relire par un conseil juridique avant publication.
export const LegalPage = ({ title, description, path, updated, children }) => (
  <main id="contenu-principal">
    <Seo title={title} description={description} path={path} />
    {/* Modèle à faire relire par un conseil juridique avant publication. */}
    <section className="bg-bordeaux text-cream py-14 md:py-16">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl">
        <h1 className="font-display text-3xl md:text-4xl font-bold">{title.split(" | ")[0]}</h1>
        <p className="mt-3 text-sm text-cream/70">Dernière mise à jour : {updated}</p>
      </div>
    </section>
    <section className="py-12 md:py-16">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl prose-legal">
        <div className="space-y-8 text-taupe leading-relaxed [&_h2]:font-display [&_h2]:text-2xl [&_h2]:font-semibold [&_h2]:text-encre [&_h2]:pt-4 [&_h3]:font-semibold [&_h3]:text-encre [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1.5 [&_a]:text-terracotta [&_a]:underline">
          {children}
        </div>
      </div>
    </section>
  </main>
);
